import React from "react";
import {
  Flex,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from "@chakra-ui/react";
import { format } from "date-fns";
import { useTranslation } from "next-i18next";
import { useSession } from "next-auth/react";

import { Product } from "@/types/product";

const EndProductInfo = ({
  product,
}: {
  product: Product;
}): React.ReactElement => {
  const { t } = useTranslation();
  const { data: session } = useSession();
  const isUserProduct =
    session?.user?.id &&
    product?.user?.id &&
    session?.user?.id === product?.user?.id;

  return (
    <Flex align={"center"} justifyContent="center" pl={"100px"} pr={"100px"}>
      <Alert status="warning" p={3} my={5}>
        <AlertIcon />
        <AlertTitle>{t("product.productEndInfo")}</AlertTitle>
        {isUserProduct && (
          <AlertDescription>
            {t("product.productEndInfoDate", {
              date: format(new Date(product?.endOfferDate), "dd.MM.yyyy"),
            })}
          </AlertDescription>
        )}
      </Alert>
    </Flex>
  );
};

export default EndProductInfo;
